import React, { useState, useEffect, useContext, useRef } from 'react';
import SearchFlightPanel from './SearchFlightPanel';
import './Flight.css';
import { LandingContext } from '../Profile/LandingContext'; // Import the context

const useInView = (options) => {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true);
                observer.unobserve(entry.target);
            }
        }, options);

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [ref, options]);

    return [ref, inView];
};


const FlightSearch = () => {
    const landingData = useContext(LandingContext);
    const [offersRef, offersInView] = useInView({ threshold: 0.1 });
    const [destinationsRef, destinationsInView] = useInView({ threshold: 0.1 });
    const [whyUsRef, whyUsInView] = useInView({ threshold: 0.1 });

    const flightDeals = [
        { airline: 'IndiGo', logoUrl: '/assets/images/airlinelogos/6E.png', title: 'Domestic Flights Bonanza', description: 'Fly to your favorite domestic destinations.', discount: 'Up to 25% OFF', type: 'percent' },
        { airline: 'Vistara', logoUrl: '/assets/images/airlinelogos/UK.png', title: 'International Getaways', description: 'Explore the world with premium comfort.', discount: 'Flat ₹5000 OFF', type: 'flat' },
        { airline: 'Air India', logoUrl: '/assets/images/airlinelogos/AI.png', title: 'Last Minute Deals', description: 'Book spontaneous trips and save big.', discount: 'Starting @ ₹2,999', type: 'price' },
    ];
    const popularDestinations = [
        { name: 'Paris, France', image: 'https://images.unsplash.com/photo-1522093007474-d86e9bf7ba6f?q=80&w=2148' },
        { name: 'Dubai, UAE', image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=2070' },
        { name: 'Kyoto, Japan', image: 'https://images.unsplash.com/photo-1542051841857-5f90071e7989?q=80&w=2070' },
        { name: 'New York, USA', image: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?q=80&w=2070' },
    ];
    const whyChooseUs = [
        { icon: 'ri-price-tag-3-line', title: 'Best Price Guarantee', text: 'We offer the most competitive prices on 300+ airlines.' },
        { icon: 'ri-secure-payment-line', title: 'Secure Payments', text: 'Enjoy hassle-free and secure payment options.' },
        { icon: 'ri-customer-service-2-line', title: '24/7 Support', text: 'Our dedicated team is here to help you around the clock.' },
    ];


    const heroStyle = {
        backgroundImage: `url("${landingData?.flightBackgroundSrc || "/assets/images/bg-homepage.jpg"}"), url("/assets/images/bg-homepage.jpg")`,
    };

    return (
        <>
            <div className="hero-section" style={heroStyle}>
                <div className="hero-grid-container">
                    <div className="hero-text-content">
                        <h1 className="hero-heading">Search and Book flights.</h1>
                        <p className="flight-hero-subtitle">Find the best flight deals for your perfect trip</p>
                    </div>
                    <div className="hero-form-content">
                        <SearchFlightPanel />
                    </div>
                </div>
            </div>
            <div className="page-content" style={{ paddingTop: 0 }}>
                <div className="container">
                    <section ref={offersRef} className={`py-5 section-container ${offersInView ? 'is-visible' : ''}`}>
                        <h2 className="section-title">Exclusive Flight Offers</h2>
                        <div className="row g-4">
                            {flightDeals.map((deal, index) => (
                                <div className="col-lg-4 col-md-6" key={index}>
                                    <div className={`offer-card offer-card-${deal.type}`}>
                                        <div className="offer-card-header">
                                            <img src={deal.logoUrl} alt={`${deal.airline} logo`} className="airline-logo" />
                                            <span className="discount-badge">{deal.discount}</span>
                                        </div>
                                        <div className="offer-card-body">
                                            <h5 className="card-title">{deal.title}</h5>
                                            <p className="card-text">{deal.description}</p>
                                            <a href="#!" className="stretched-link">Book Now <i className="ri-arrow-right-line"></i></a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section ref={destinationsRef} className={`py-5 section-container ${destinationsInView ? 'is-visible' : ''}`}>
                        <h2 className="section-title">Explore Popular Destinations</h2>
                        <div className="row g-4">
                            {popularDestinations.map((dest, index) => (
                                <div className="col-lg-3 col-md-6" key={index}>
                                    <a href="#!" className="destination-card-modern">
                                        <img src={dest.image} alt={dest.name} className="card-img" />
                                        <div className="card-img-overlay">
                                            <h4 className="card-title">{dest.name}</h4>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section ref={whyUsRef} className={`py-5 section-container why-us-section ${whyUsInView ? 'is-visible' : ''}`}>
                        <h2 className="section-title">Why Book With Us?</h2>
                        <div className="row g-4">
                            {whyChooseUs.map((item, index) => (
                                <div className="col-lg-4 col-md-6" key={index}>
                                    <div className="why-us-item">
                                        <div className="why-us-icon">
                                            <i className={item.icon}></i>
                                        </div>
                                        <div className="why-us-content">
                                            <h5 className="title">{item.title}</h5>
                                            <p className="text">{item.text}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                </div>
            </div>
        </>
    );
};

export default FlightSearch;